import type { JSX } from "solid-js";

export function resolveIconStyle(style?: JSX.CSSProperties): JSX.CSSProperties {
  return {
    width: "20px",
    height: "20px",
    "min-width": 0,
    "min-height": 0,
    "max-width": "100%",
    "max-height": "100%",
    overflow: "hidden",
    ...style
  };
}
